<div class="mb-4">Tick the appropriate valve(s) to be tested :</div>

<mat-accordion class="example-headers-align">
    <mat-expansion-panel
        *ngFor="let valve of valves; let i = index"
        [expanded]="step === i"
        (opened)="setStep(i)"
        hideToggle
    >
        <mat-expansion-panel-header class="custom-header-bgColor">
            <mat-panel-title>
                {{ valve.title }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <app-greasing-pressure-table
            [valveType]="valve.type"
            [formGroup]="valve.formGroup"
        >
        </app-greasing-pressure-table>
        <mat-action-row>
            <button mat-button color="warn" (click)="prevStep()" *ngIf="i > 0">
                Previous
            </button>
            <button
                mat-button
                color="primary"
                (click)="nextStep()"
                *ngIf="i < valves.length - 1"
            >
                Next
            </button>
        </mat-action-row>
    </mat-expansion-panel>
</mat-accordion>
